export default __webpack_public_path__ + "static/media/vector-left.1846092a.svg";